// extracted by mini-css-extract-plugin
module.exports = {"FeeinfoContainer":"FeeInfo_FeeinfoContainer__Lr0lp","TitleContainer":"FeeInfo_TitleContainer__1dNc1","FeeContainer":"FeeInfo_FeeContainer__sS7VS"};